import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api, errText } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { ShieldCheck, Lock, Loader2 } from "lucide-react";

export default function StaffLogin() {
  const navigate = useNavigate();
  const { user, setUser } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") navigate("/admin", { replace: true });
    else if (user && user.role === "moderator") navigate("/moderator", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/staff-login", { username, password });
      setUser(data);
      toast.success(`Welcome, ${data.name}`);
      navigate(data.role === "admin" ? "/admin" : "/moderator", { replace: true });
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0E1B38] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <span className="h-14 w-14 rounded-2xl bg-[#F5551E] flex items-center justify-center mb-3">
            <ShieldCheck size={28} className="text-white" />
          </span>
          <h1 className="font-display text-2xl font-extrabold text-white">Staff Access</h1>
          <p className="text-slate-400 text-sm mt-1">CritterPosts.ca control center</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-6 space-y-4 shadow-2xl">
          <div>
            <Label htmlFor="username" className="text-[#12234A]">Username</Label>
            <Input id="username" data-testid="staff-username" value={username} onChange={(e) => setUsername(e.target.value)} required autoComplete="username" className="mt-1 h-11 rounded-xl" placeholder="username" />
          </div>
          <div>
            <Label htmlFor="password" className="text-[#12234A]">Password</Label>
            <Input id="password" type="password" data-testid="staff-password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" className="mt-1 h-11 rounded-xl" placeholder="••••••••" />
          </div>
          <Button type="submit" disabled={loading} data-testid="staff-login-btn" className="w-full h-11 rounded-xl bg-[#12234A] hover:bg-[#0E1B38] text-white font-semibold gap-2">
            {loading ? <Loader2 className="animate-spin" size={18} /> : <Lock size={16} />} Sign in
          </Button>
          <p className="text-xs text-center text-slate-400 flex items-center justify-center gap-1"><Lock size={11} /> Authorized personnel only</p>
        </form>
      </div>
    </div>
  );
}
